import { createMockNewsFeed } from '@/services/newsMockData';
import type { NewsFeedResponse } from '@/types/api';

/**
 * Fetch the ranked news feed. Public endpoint: works logged-out; logged-in
 * requests additionally get a `saved` flag per item.
 *
 * In development the feed falls back to createMockNewsFeed() when the backend
 * has nothing to serve — a local Redis without the `news:v1:latest` blob
 * returns an empty item list, which would otherwise leave the page stuck on
 * its empty state. Real items always win when the blob is populated, and the
 * fallback is stripped from production builds.
 */
async function fetchNewsFeed(limit = 50): Promise<NewsFeedResponse> {
  const response = await fetch(`/data/news?limit=${limit}`, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
    credentials: 'same-origin',
  });
  if (!response.ok) {
    throw new Error(`Failed to load news feed (${response.status})`);
  }
  const feed: NewsFeedResponse = await response.json();
  if (import.meta.env.DEV && feed.items.length === 0) {
    return createMockNewsFeed(limit);
  }
  return feed;
}

export { fetchNewsFeed };
